<template>
  <div class="scope-edition-form">
    <v-alert
      v-model="alert"
      dismissible
      color="error"
      border="left"
      elevation="2"
      colored-border
      icon="priority_high"
    >An error happened while saving: {{errorDisplay(updateError)}}</v-alert>
    <v-row no-gutters>
      <v-btn class="my-4 mx-1" :color="editable ? 'error': 'primary'" @click="cancelEdition">
        <v-icon dark left>{{editable ? 'cancel' : 'mdi-pencil'}}</v-icon>
        {{ editable ? 'Cancel' : 'Edit' }}
      </v-btn>
      <v-btn class="my-4 mx-1" color="success" v-if="editable" @click="save">
        <v-icon dark left>save</v-icon>Save
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="my-4 mx-1" color="grey lighten-3" @click="$emit('refresh')">
        <v-icon left>refresh</v-icon>Refresh
      </v-btn>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-text-field label="UUID" outlined v-model="newUuid" disabled class="pa-1"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          label="name*"
          placeholder="Name..."
          outlined
          v-model="newName"
          :rules="[isNameValid || 'This field is required, and must contain 3 letters at least']"
          required
          :disabled="!editable"
          class="pa-1"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-textarea
      label="description"
      placeholder="Description..."
      class="pa-1"
      rows="2"
      outlined
      :disabled="!editable"
      v-model="newDescription"
    ></v-textarea>
  </div>
</template>
<script>
import { mapState } from "vuex";
import mixin from "@/mixins";
export default {
  props: {
    uuid: { type: String },
    name: { type: String },
    description: { type: String }
  },
  mixins: [mixin],
  data() {
    return {
      editable: false,
      newUuid: "",
      newName: "",
      newDescription: "",
      alert: false
    };
  },
  computed: {
    ...mapState({
      updateError: state => state.scopes.updateOne.error
    })
  },
  watch: {
    uuid() {
      this.newUuid = this.uuid;
    },
    name() {
      this.newName = this.name;
    },
    description() {
      this.newDescription = this.description;
    },
    updateError() {
      if (this.updateError) {
        this.alert = true;
      } else {
        this.alert = false;
      }
    }
  },
  methods: {
    isNameValid() {
      return this.name ? this.name.length >= 3 : false;
    },
    cancelEdition() {
      if (this.editable) {
        this.newUuid = this.uuid;
        this.newName = this.name;
        this.newDescription = this.description;
      }
      this.editable = !this.editable;
    },
    save() {
      this.$emit("save", this.newName, this.newDescription);
    },
    saveCallback() {
      this.editable = !this.editable;
    }
  }
};
</script>